// extracted by mini-css-extract-plugin
export default {"btn":"wishlist_btn__j+5eD","icon":"wishlist_icon__ivamh","txt":"wishlist_txt__MqvYB"};